import { createFileRoute } from "@tanstack/react-router"

import { LabAiSettingsPage } from "@/features/settings/components/lab-ai-settings-page"
import { requirePermissionRouteAccess } from "@/features/authz/require-permission-route-access"

export const Route = createFileRoute("/dashboard/settings/lab-ai/")({
	beforeLoad: async ({ context }) => await requirePermissionRouteAccess(context.queryClient, "lab.ai.settings.read"),
	component: LabAiSettingsPage,
})
